import React from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import { languageSuffixMap } from "constant"

import { Button, Modal } from "components"
import { thousandSeparator } from "utils"
import LfsSpecificationsGroup from "./LfsSpecificationsGroup"
import KioskCustomBuilder from "./KioskCustomBuilder"
import { getSelectedSpecificationTotal } from "./customBuilder"
import classes from "./index.module.scss"
import { useSelector } from "react-redux"

const KioskFoodSpecifications = props => {
  const {
    food,
    quantity,
    onConfirm,
    hasCustomBuilder = false,
    selectedOption,
    selectedSpecificationItems,
    setSelectedSpecificationItems,
    openFoodSpecificationsModal,
    setOpenFoodSpecificationsModal
  } = props

  const [t, i18n] = useTranslation()

  const foodSpecificationsMap =
    useSelector(state => state.foodSpecificationsMap)

  const handleExit = () => {
    setOpenFoodSpecificationsModal(false)
  }

  const getFoodSpecifications = () => {
    const foodSpecifications = []

    food.specificationIds.forEach((specificationId) => {
      const specifcation =
        foodSpecificationsMap[specificationId]

      if (!specifcation) return

      foodSpecifications.push(specifcation)
    })

    return foodSpecifications
  }

  const foodSpecifications =
    getFoodSpecifications()

  const totalSpecifications =
    getSelectedSpecificationTotal(selectedSpecificationItems)

  const total =
    ((selectedOption?.salePrice || 0) + totalSpecifications) * quantity

  const field =
    `name${languageSuffixMap[i18n.language]}`

  const optionName = selectedOption?.[field] || ""

  return (
    <Modal
      show={openFoodSpecificationsModal}
      centered
      size={hasCustomBuilder ? "lg" : undefined}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button
            className={classes["close"]}
            onClick={handleExit}
          >
            <MdClose size={25} />
          </button>

          <h3 className={classes["title"]}>
            {hasCustomBuilder ? "سفارشی سازی محصول" : t("انتخاب_افزودنی_ها")}
          </h3>

          <p className={classes["name"]}>
            {food[`name${languageSuffixMap[i18n.language]}`]}{" "}
            {food.options.length > 1 ? `(${optionName})` : ""}
          </p>
        </div>

        {hasCustomBuilder
          ? <KioskCustomBuilder
              food={food}
              selectedOption={selectedOption}
              selectedSpecificationItems={selectedSpecificationItems}
              setSelectedSpecificationItems={setSelectedSpecificationItems}
              onComplete={onConfirm}
            />
          : foodSpecifications.map(specification =>
              <div
                key={specification._id}
                className={classes["specification-group"]}
              >
                <LfsSpecificationsGroup
                  specification={specification}
                  selectedSpecificationItems={selectedSpecificationItems}
                  setSelectedSpecificationItems={setSelectedSpecificationItems}
                />
              </div>
            )
        }

        {!hasCustomBuilder &&
          <div className={classes["footer"]}>
            <Button
              color="success"
              fullWidth
              onClick={onConfirm}
              className={classes["button"]}
            >
              {t("افزودن")} ({thousandSeparator(total)})
            </Button>
          </div>
        }
      </div>
    </Modal>
  )
}

export default KioskFoodSpecifications
